import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { http } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const AuthCallback = () => {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(hash.slice(1)).get("session_id");
    http.post("/auth/session", null, { headers: { "X-Session-ID": sid } })
      .then(({ data }) => {
        setUser(data);
        toast.success(`Bienvenue, ${data?.name?.split(" ")[0] ?? ""}`);
        navigate(data?.is_admin ? "/admin" : "/compte", { replace: true });
      })
      .catch(() => {
        toast.error("La connexion a échoué, réessayez.");
        navigate("/", { replace: true });
      });
  }, [hash, navigate, setUser]);

  return <div data-testid="auth-callback" className="min-h-screen" />;
};
